<app-disparo-automatizado
  statusGroup="PROGRAMACOES"
  tipoProgramacaoInicial="Recorrente">
</app-disparo-automatizado>
